export default __webpack_public_path__ + "29135a1d5180d70ac995b949f489a51d.png";